import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgbCalendar, NgbDate, NgbDatepicker, NgbDatepickerNavigateEvent } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-calendar',
    templateUrl: './calendar.component.html',
    styleUrls: ['./calendar.component.scss'],
})
export class CalendarComponent implements OnInit {
    public currentMonth: string;
    public startDate: NgbDate | null = null;
    public endDate: NgbDate | null = null;
    public hoveredDate: NgbDate | null = null;

    @ViewChild('dp', { static: false }) datepicker: NgbDatepicker;

    @Output() dateRangeSelected = new EventEmitter<{ startDate: NgbDate | null; endDate: NgbDate | null }>();
    constructor(private calendar: NgbCalendar) {}

    ngOnInit(): void {
        const today = this.calendar.getToday();
        this.currentMonth = this.getMonthName(today.month) + ' ' + today.year;
    }

    onMonthChange(event: NgbDatepickerNavigateEvent): void {
        this.currentMonth = this.getMonthName(event.next.month) + ' ' + event.next.year;
    }

    onDateSelect(date: NgbDate): void {
        if (!this.startDate || (this.startDate && this.endDate)) {
            this.startDate = date;
            this.endDate = null;
        } else if (!this.endDate && date.after(this.startDate)) {
            this.endDate = date;
        } else {
            this.startDate = date;
            this.endDate = null;
        }
    }

    onDateHover(date: NgbDate): void {
        if (this.startDate && !this.endDate) {
            this.hoveredDate = date;
        }
    }

    isSelected(date: NgbDate): boolean {
        return this.isSameDate(date, this.startDate) || this.isSameDate(date, this.endDate);
    }

    isInRange(date: NgbDate): boolean {
        if (this.startDate && this.endDate) {
            return date.after(this.startDate) && date.before(this.endDate);
        } else if (this.startDate && this.hoveredDate) {
            return date.after(this.startDate) && date.before(this.hoveredDate);
        }
        return false;
    }

    isRangeStart(date: NgbDate): boolean {
        return this.isSameDate(date, this.startDate);
    }

    isRangeEnd(date: NgbDate): boolean {
        return this.isSameDate(date, this.endDate);
    }

    private isSameDate(date1: NgbDate | null, date2: NgbDate | null): boolean {
        return !!date1 && !!date2 && date1.equals(date2);
    }

    private getMonthName(month: number): string {
        const months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
        return months[month - 1];
    }
    onDateRangeSelected(): void {
        this.dateRangeSelected.emit({ startDate: this.startDate, endDate: this.endDate });
    }
    clear(): void {
        this.startDate = null;
        this.endDate = null;
        this.hoveredDate = null;
        this.datepicker.navigateTo(this.calendar.getToday());
        this.dateRangeSelected.emit({ startDate: null, endDate: null });
    }
}
